import { render, staticRenderFns } from "./ItemImportInterface.vue?vue&type=template&id=3ff89045"
import script from "./ItemImportInterface.vue?vue&type=script&lang=js"
export * from "./ItemImportInterface.vue?vue&type=script&lang=js"
import style0 from "./ItemImportInterface.vue?vue&type=style&index=0&id=3ff89045&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports